import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Receipt from '../../../svg/Receipt.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';
import { estimatedGroceryFees, serviceCharges } from '../../../const';
import { getServiceTotalEstimates } from '../../../helpers/serviceUtil';

class EstimatedPrice extends Component {
  state = {
    client: {
      portion_size: '',
      code: '',
    },
    isCurrentStep: false,
  };

  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    let { code = '', portion_size = '' } = this.state.client;
    const { isCurrentStep } = this.state;
    portion_size = portion_size || 'medium';

    const groceryEstimate = estimatedGroceryFees[portion_size] || [];

    return (
      <InfoBox headline="Estimated Price" icon={<Receipt />}>
        <div className="onboarding-new__receipt">
          <div className="onboarding-new__receipt-item">
            <p>Service Fee</p>
            <p>${serviceCharges['serviceFee'].toFixed(2)}</p>
          </div>
          <div className="onboarding-new__receipt-item">
            <p>Grocery Estimate</p>
            <p>
              {groceryEstimate.map((est) => '$' + est.toFixed(2)).join('-')}
            </p>
          </div>
          <p className="onboarding-new__receipt-subline">
            Grocery estimate is a little higher for your first service.
          </p>
          <div className="onboarding-new__receipt-item">
            <p>Tip</p>
            <p>${serviceCharges['tip'].toFixed(2)}</p>
          </div>
          <p className="onboarding-new__receipt-subline">
            100% of the tip goes directly to your chef.
          </p>
          <div className="onboarding-new__receipt-item">
            <p>Travel</p>
            <p>${serviceCharges['travel'].toFixed(2)}</p>
          </div>
          <div className="onboarding-new__receipt-item">
            <p>Tax</p>
            <p>${serviceCharges['tax'].toFixed(2)}</p>
          </div>

          <Formsy
            onValid={() => setStepAsValid(isCurrentStep)}
            onInvalid={() => setStepAsInvalid(isCurrentStep)}
          >
            <div className="row">
              <div className="row__item row__item--full onboarding-new__promo-code">
                <FormsyInputMui
                  name="code"
                  placeholder="Promo Code"
                  value={code}
                  onChange={this.handleChange}
                  showError={this.state.formIsInvalid}
                  autoComplete="off"
                />
              </div>
            </div>
          </Formsy>
          <p className="onboarding-new__receipt-subline">
            The code will be reflected on your first bill.
          </p>

          <div className="onboarding-new__receipt-item">
            <p>Estimated Total</p>
            <p className="onboarding-new__receipt-total">
              {getServiceTotalEstimates(portion_size)
                .map((est) => '$' + est.toFixed(2))
                .join('-')}
            </p>
          </div>
          <p className="onboarding-new__receipt-subline">
            The code will be reflected on your first bill.
          </p>
        </div>
      </InfoBox>
    );
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ client: { ...this.state.client, [name]: value } });
  };

  handleClientUpdate = () => {
    const { client } = this.state;
    this.props.updateClient(client);
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default EstimatedPrice;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/EstimatedPrice.js